import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { useOttOverlay } from '../../../contexts'
import { ICategoryTreeItem } from '../../../types'
import { ottRoot } from '../../Api'
import {
  NavItemWrapper,
  ProfileNavItemDiv,
  ReshetNavItemDiv,
  SearchLogo,
} from './Navigation.style'
import Link from 'next/link'
import { mediaCdn } from '../../../components/Player/Helpers'
import { Search } from '../../../icons'

export const NavItem = ({
  data,
  isIos,
}: {
  data: ICategoryTreeItem
  isIos: boolean
}) => {
  const { hp, activePage, searchPageID } = useOttOverlay()

  const isSearch = useMemo(
    () => data.id === searchPageID,
    [data.id, searchPageID]
  )
  const href = useMemo(
    () =>
      ottRoot +
      '/' +
      (hp === data.id ? '' : `screen/${isSearch ? 'search/' : ''}${data.id}`),
    [data.id, hp, isSearch]
  )

  return (
    <NavItemWrapper
      theme={{
        active: activePage === data.id && !isSearch,
        isSearch: isSearch,
        programList: false,
        paddingBottom: 1.1,
        iosPaddingBottom: isIos ? 0 : 20,
      }}
    >
      <Link href={href}>
        {isSearch ? (
          <SearchLogo>
            <Search />
          </SearchLogo>
        ) : (
          data.name
        )}
      </Link>
    </NavItemWrapper>
  )
}

export const ProfileNavItem = () => {
  const { setActivePage, activePage } = useOttOverlay(),
    router = useRouter(),
    _onClick = () => {
      router.push(ottRoot + '/profile', undefined, {
        shallow: true,
      })
      setActivePage('profile')
    }

  return (
    <ProfileNavItemDiv onClick={_onClick} isSearch={false}>
      {activePage === 'profile' ? (
        <img
          src={mediaCdn + 'v1707053403/dev-uploads/2024/862013.png'}
          alt='profile'
        />
      ) : (
        <img
          src='https://media3.reshet.tv/image/upload/v1703506401/ott/User.svg'
          alt='profile'
        />
      )}
    </ProfileNavItemDiv>
  )
}
export const ReshetNavItem = () => {
  return (
    <Link href={'/'}>
      <ReshetNavItemDiv isSearch={false}>לאתר רשת 13</ReshetNavItemDiv>
    </Link>
  )
}
